import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { Button } from "@mui/material";
import AddForm from "./addForm";
import {
  useGetSubCategoriesQuery,
  useAddSubCategoryMutation,
  useUpdateSubCategoryMutation,
  useDeleteSubCategoryMutation,
} from "slices/beautyApp/subCatSlice";
import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";

function SubCategories() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1); // API expects 1-based
  const [limit, setLimit] = useState(10);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [add] = useAddSubCategoryMutation();
  const [update] = useUpdateSubCategoryMutation();
  const [del] = useDeleteSubCategoryMutation();
  const auth = useSelector((state) => state.auth.auth?.user);

  const {
    data: subCat,
    isLoading,
    refetch,
  } = useGetSubCategoriesQuery({ page, limit, search });

  const col = [
    { display: "Name", key: "name", type: "display" },
    {
      display: "Image",
      key: "image",
      type: "image",
      style: { width: "100px", height: "100px", borderRadius: "20%" },
    },
  ];

  const canEdit = hasActionAccess(auth, "Beauty App", "Sub-Categories", "edit");
  const canDelete = hasActionAccess(
    auth,
    "Beauty App",
    "Sub-Categories",
    "delete"
  );

  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1); // Reset to first page on search
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    setEditing(row);
    setOpen(true);
  };

  const handleAdd = () => {
    setEditing(null);
    setOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this sub-category?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const handleSubmit = async (data) => {
    try {
      let formData = new FormData();
      formData.append("category", data.category);
      formData.append("name", data.name);
      formData.append("image", data.image);
      formData.append("metaTitle", data.metaTitle);
      formData.append("metaDescription", data.metaDescription);
      formData.append("description", data.description);
      if (data.keywords.length > 0) {
        for (let i = 0; i < data.keywords.length; i++) {
          formData.append("keywords", data.keywords[i]);
        }
      }
      if (editing) {
        await update({ id: data._id, body: formData }).unwrap();
      } else {
        await add(formData).unwrap();
      }
      refetch();
      setOpen(false);
    } catch (e) {
      console.log("e===========>", e);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setEditing(null);
  };

  const canAdd = hasActionAccess(auth, "Beauty App", "Sub-Categories", "add");

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AddForm
        open={open}
        onClose={handleClose}
        initialData={editing}
        onSubmit={handleSubmit}
      />

      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add Sub-Category
        </Button>
      )}

      <Tables
        title={"Sub-Categories"}
        handleSearch={handleSearchChange}
        totalPages={subCat?.data?.pagination?.totalPages || 0}
        data={subCat?.data?.data || []}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default SubCategories;
